__turbopack_context__.v({
  "helios-sticky-scroll": "sXVMBW_helios-sticky-scroll",
  "helios-sticky-scroll--nav-none": "sXVMBW_helios-sticky-scroll--nav-none",
  "helios-sticky-scroll--split": "sXVMBW_helios-sticky-scroll--split",
  "helios-sticky-scroll--staged": "sXVMBW_helios-sticky-scroll--staged",
  "helios-sticky-scroll--wide": "sXVMBW_helios-sticky-scroll--wide",
  "helios-sticky-scroll__block": "sXVMBW_helios-sticky-scroll__block",
  "helios-sticky-scroll__block--dark": "sXVMBW_helios-sticky-scroll__block--dark",
  "helios-sticky-scroll__container": "sXVMBW_helios-sticky-scroll__container",
  "helios-sticky-scroll__container--mdWide": "sXVMBW_helios-sticky-scroll__container--mdWide",
  "helios-sticky-scroll__container--wide": "sXVMBW_helios-sticky-scroll__container--wide",
  "helios-sticky-scroll__content": "sXVMBW_helios-sticky-scroll__content",
  "helios-sticky-scroll__header": "sXVMBW_helios-sticky-scroll__header",
  "helios-sticky-scroll__header--sidebar": "sXVMBW_helios-sticky-scroll__header--sidebar",
  "helios-sticky-scroll__inline-stage": "sXVMBW_helios-sticky-scroll__inline-stage",
  "helios-sticky-scroll__layout": "sXVMBW_helios-sticky-scroll__layout",
  "helios-sticky-scroll__sidebar": "sXVMBW_helios-sticky-scroll__sidebar",
  "helios-sticky-scroll__sidebar-footer": "sXVMBW_helios-sticky-scroll__sidebar-footer",
  "helios-sticky-scroll__sidebar-header": "sXVMBW_helios-sticky-scroll__sidebar-header",
  "helios-sticky-scroll__sidebar-header-content": "sXVMBW_helios-sticky-scroll__sidebar-header-content",
  "helios-sticky-scroll__sidebar-header-content--dark-overlay": "sXVMBW_helios-sticky-scroll__sidebar-header-content--dark-overlay",
  "helios-sticky-scroll__stage": "sXVMBW_helios-sticky-scroll__stage",
  "helios-sticky-scroll__stage-frame": "sXVMBW_helios-sticky-scroll__stage-frame",
  "helios-sticky-scroll__stage-item": "sXVMBW_helios-sticky-scroll__stage-item",
  "helios-sticky-scroll__staged-step": "sXVMBW_helios-sticky-scroll__staged-step",
  "helios-sticky-scroll__step": "sXVMBW_helios-sticky-scroll__step",
  "helios-sticky-scroll__step--active": "sXVMBW_helios-sticky-scroll__step--active",
  "helios-sticky-scroll__step-item": "sXVMBW_helios-sticky-scroll__step-item",
  "helios-sticky-scroll__step-label": "sXVMBW_helios-sticky-scroll__step-label",
  "helios-sticky-scroll__step-label--dark-overlay": "sXVMBW_helios-sticky-scroll__step-label--dark-overlay",
  "helios-sticky-scroll__steps": "sXVMBW_helios-sticky-scroll__steps",
});
